(function () {
  'use strict';

  /* Formularios de compra: sincroniza precio y selector por edad */
  document.querySelectorAll('[data-buy]').forEach(function (buy) {
    var select = buy.querySelector('[data-variant-select]');
    var reco = buy.querySelector('[data-reco]');
    var priceEl = buy.querySelector('[data-price]');
    var compareEl = buy.querySelector('[data-compare]');
    var addBtn = buy.querySelector('[name="add"]');

    function sync() {
      if (!select) return;
      var opt = select.options[select.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl && opt.dataset.compare) compareEl.textContent = opt.dataset.compare;
      if (addBtn) {
        addBtn.disabled = opt.disabled;
        addBtn.textContent = opt.disabled ? 'Agotado' : 'Agregar al carrito';
      }
    }
    if (select) select.addEventListener('change', sync);

    buy.querySelectorAll('[data-age-finder] input').forEach(function (input) {
      input.addEventListener('change', function () {
        var power = '+' + input.value;
        var match = -1;
        if (select) {
          for (var i = 0; i < select.options.length; i++) {
            if (select.options[i].text.indexOf(power) !== -1) { match = i; break; }
          }
          if (match > -1) { select.selectedIndex = match; sync(); }
        }
        if (reco) {
          reco.hidden = false;
          reco.textContent = match > -1
            ? 'Te recomendamos empezar con ' + power + '. Ya la seleccionamos abajo.'
            : 'Te recomendamos empezar con ' + power + '.';
        }
      });
    });
  });

  /* Demo de lectura en la home */
  document.querySelectorAll('[data-demo]').forEach(function (demo) {
    var btn = demo.querySelector('[data-demo-toggle]');
    var cap = demo.querySelector('[data-demo-caption]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var on = demo.classList.toggle('is-on');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = on ? 'Quitarme los lentes' : 'Ponerme los lentes';
      if (cap) cap.textContent = on
        ? 'Y así con el aumento correcto, sin alejar nada.'
        : 'Así se ve un correo cuando empieza la presbicia.';
    });
  });

  /* Barra fija móvil de la home */
  var sticky = document.querySelector('[data-sticky]');
  var hero = document.querySelector('[data-hero]');
  var buyZone = document.querySelector('[data-buy-zone]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var heroOut = false, buyIn = false;
    var link = sticky.querySelector('a');
    var update = function () {
      var show = heroOut && !buyIn;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; update(); }).observe(hero);
    if (buyZone) new IntersectionObserver(function (e) { buyIn = e[0].isIntersecting; update(); }).observe(buyZone);
  }

  /* Galería de producto */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.src = b.dataset.src;
        main.removeAttribute('srcset');
        main.alt = b.dataset.alt || '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  });

  /* Orden de colección */
  document.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Cerrar menú móvil al elegir un enlace */
  document.querySelectorAll('.mobile-menu a').forEach(function (a) {
    a.addEventListener('click', function () {
      var d = a.closest('details'); if (d) d.removeAttribute('open');
    });
  });
})();
